// mutations
const SET_MINI = (state, payload) => {
  state.mini = payload;
};
const SET_RESULTMENU = (state, payload) => {
  state.res_menu = payload;
};
const SET_IDMENU = (state, payload) => {
  state.idMenu = payload;
};
const SET_IDPASS = (state, payload) => {
  state.idPass = payload;
};
const SET_TEMPPASSWORD = (state, payload) => {
  state.temp_pass = payload;
};
const SET_PROGRESS = (state, payload) => {
  state.res_progres = payload;
};
const SET_IDUSER = (state, payload) => {
  state.idUser = payload;
};
const SET_CHECKMENUS = (state, payload) => {
  state.temp_cekmenu = payload;
};
const SET_RESMENUCEK = (state, payload) => {
  state.res_menucek = payload;
};
const SET_USERROLE = (state, payload) => {
  state.roles = payload;
};
export default {
  SET_USERROLE,
  SET_IDUSER,
  SET_PROGRESS,
  SET_TEMPPASSWORD,
  SET_IDPASS,
  SET_MINI,
  SET_IDMENU,
  SET_RESULTMENU,
  SET_CHECKMENUS,
  SET_RESMENUCEK
};
